export const EDUCATION_WEB = 'edu-web';
export const MYM_WEB = 'mym-web';
export const CLEANING_WEB = 'cleaning-web';
export const LAUNDRY_WEB = 'laundry-web';
export const FACILITY_PORTAL_WEB = 'facility-portal-web';
